var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{directives:[{name:"lazyload",rawName:"v-lazyload"}],attrs:{"data-src":_vm.artwork_url_with_size,"data-err":_vm.dataURI},on:{"click":function($event){return _vm.$emit('click')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }